import ListHeader from '@/components/ListHeader'
import ListTable from '@/components/ListTable'
import { mapState } from 'vuex'

export default {
    components: {
        ListHeader,
        ListTable,
    },
    
    data() {
        return {
            fields: [
                {
                    key: 'name',
                    label: '分類',
                },
                {
                    key: 'products',
                    label: '商品數量',
                    formatter: value => {
                        return value.length + '項'
                    },
                },                
                {
                    key: 'actions',
                    label: '功能',
                    thStyle: { width: '25%' },
                }
            ]
        }
    },

    computed: {
        ...mapState({
            categories: state => state.categories,
        })
    },

    methods: {
        removeCategory({ id }) {
            this.$store.dispatch('deleteCategory', id)
        }
    }
}